import { Component, HostBinding, Input } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-evisitor-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  animations: [
    trigger('fadeInAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('.5s', style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class LoaderComponent {
  @HostBinding('class.disc-spinner-container')
  readonly staticClass: boolean = true;
  @Input() busy: boolean;
  @Input() size: number = 100;
  @Input() globe: boolean = true;
}
